import { useEffect, useState } from "react";

const StudentInfo = ({ data }) => {
  const [key, setKey] = useState("");

  useEffect(() => {
     console.log(data);
    // console.log(key);
  }, [key]);

  return (
    <>
      {data && data._id && (
        <div
          className="lead-remarks mx-3"
          style={{ marginTop: "96px", height: "100vh", overflowY: "auto" }}
        >
          <div className="">
            <div
              className=""
              style={{
                fontSize: "22px",
                fontWeight: "500",
                paddingLeft: "22px",
              }}
            >
              PERSONAL INFORMATION
            </div>
            <div
              className=""
              style={{
                marginInline: "15px",
                marginTop: "5px",
                height: "2px",
                backgroundColor: "#E5E9EB",
                width: "97%",
              }}
            >
              {" "}
            </div>
          </div>

          <div className="col-md-10 mt-3">


            <div className="spContent31 mx-3 my-4" style={{display:'flex',flexDirection:'column', width:'100%'}}>
              <div className="lpContent32" > Please provide a valid email address for course updates</div>
              <div className="lpContent33">{data?.email}</div>
            </div>

            <div className="spContent31 mx-3 my-4" style={{display:'flex',flexDirection:'column', width:'100%'}}>
              <div className="lpContent32">What is your primary area of interest within law?</div>
              <div className="lpContent33">{data?.interestArea}</div>
            </div>

            <div className="spContent31 mx-3 my-4" style={{display:'flex',flexDirection:'column', width:'100%'}}>
              <div className="lpContent32">Do you have any prior legal education or professional experience?</div>
              <div className="lpContent33">
                {data?.experience} 
              </div>
            </div>

            <div className="spContent31 mx-3 my-4" style={{display:'flex',flexDirection:'column', width:'100%'}}>
              <div className="lpContent32">Why are you interested in this LLM crash course?</div>
              <div className="lpContent33">{data.interest} </div>
            </div>

            <div className="spContent31 mx-3 my-4" style={{display:'flex',flexDirection:'column', width:'100%'}}>
              <div className="lpContent32">What days and times are suitable for you for the course?</div>
              <div className="lpContent33">{data?.availability}</div>
            </div>
            <div className="spContent31 mx-3 my-4" style={{display:'flex',flexDirection:'column', width:'100%'}}>
              <div className="lpContent32">Enter your phone number for urgent communications.</div>
              <div className="lpContent33">{data?.phone}</div>
            </div>
            

            
          </div>

        </div>
      )}
    </>
  );
};

export default StudentInfo;
